class BackInStock extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleTriggerClick = this.handleTriggerClick.bind(this)
    this.handleMobileTriggerClick = this.handleMobileTriggerClick.bind(this)

    this.listeners.add(document, 'click', this.handleTriggerClick)

    this.listeners.add(document, 'click', this.handleMobileTriggerClick)
  }

  handleTriggerClick () {
    const clickedTriggerEl = event.target.closest(
      '[data-back-in-stock-external-el="trigger"]',
    )

    if (!clickedTriggerEl) return

    this.externalEls.title.element.textContent = this.dataset.title.replace(
      '[size]',
      this.dataset.variantTitle,
    )

    if ('_RestockRocket' in window) {
      // eslint-disable-next-line no-underscore-dangle
      window._RestockRocket.openInlineForm(
        window.bis.product,
        this.dataset.variantId,
        null,
        '#stoq-container',
        'afterbegin',
      )
    }
  }

  handleMobileTriggerClick (event) {
    const clickedTriggerEl = event.target.closest(
      '[data-back-in-stock-external-el="mobiletrigger"]',
    )

    if (!clickedTriggerEl) return

    this.externalEls.title.element.textContent = this.dataset.title.replace(
      '[size]',
      clickedTriggerEl.dataset.variantTitle,
    )

    if ('_RestockRocket' in window) {
      // eslint-disable-next-line no-underscore-dangle
      window._RestockRocket.openInlineForm(
        window.bis.product,
        clickedTriggerEl.dataset.variantId,
        null,
        '#stoq-container',
        'afterbegin',
      )
    }
  }
}

if (!customElements.get('back-in-stock')) {
  customElements.define('back-in-stock', BackInStock)
}
